<div class="wrap">
  <h2>{{data.title}}</h2>
  <p>{{data.text}}</p>

  <div class="btn_action">
    <button class="back" (click)="dialogRef.close()">Annuler</button>
    <button class="confirm" (click)="deleteItem()">Supprimer</button>
  </div>
</div>